<template>
  <div :class="['fb-head', {'no-fixed': noFixed, 'head-white': headWhite}, ...headClass]" :style="styles" @touchmove.prevent>
    <div class="fb-head-back" @click="routeBack($event)">
      <img class="back-icon" :src="backIcon" alt="">
    </div>
    <div v-if="!headTitleLayout" class="fb-head-title" :class="{'long-title-style' : titleStyle}">{{title}}</div>
    <div v-else class="slot-titlt-warp">
      <slot name="titleLayout"></slot>
    </div>
    <div class="fb-head-right" @click="$emit('right', $event)">
      <span class="right-icon" v-if="needIcon === true> -1"></span>
      <span class="right-img" v-else-if="this.$route.path.indexOf('/record/detail') > -1"></span>
      <span class="right-text" v-else @click="$emit('rightClick')">{{rightText}}</span>
      <slot name="rightIcon" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FbHead',
  props: {
    titleStyle: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    styles: {
      type: Object,
      default: null
    },
    backIcon: {
      type: String,
      default: require('../../assets/images/common/icon_back_arrow.png')
    },
    headTitleLayout: {
      type: Boolean,
      default: false
    },
    headClass: {
      type: Array,
      default: () => []
    },
    needIcon: {
      type: Boolean,
      default: false
    },
    noFixed: {
      type: Boolean,
      default: false
    },
    isNomalBack: {
      type: Boolean,
      default: false
    },
    headWhite: { // 白色背景
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'canIUseCanGoBack'
    ])
  },
  data () {
    return {
      canGoBack: false
    }
  },
  mounted () {
    // console.log('head', this.canIUseCanGoBack)
    if (this.canIUseCanGoBack) {
      this.$jfs.canGoBack().then(res => {
        // console.log('head canGoBack', res)
        this.canGoBack = res.canGoBack
      })
    }
  },
  methods: {
    /*
    * 如果是从原生点进来则返回true 否则返回false
    */
    returnApp () {
      if (this.canIUseCanGoBack && !this.canGoBack) {
        localStorage.removeItem('access_token')
        this.$jfs.backNativeApp()
        return true
      }
      return false
    },
    /*
    * 如果不是从原生点进来则调用原先返回的方法
    * 就算从原生进来，如果是活动详情，也调用原来返回方法
    */
    routeBack (e) {
      if (this.isNomalBack) {
        this.$emit('back', e)
        return
      }
      if (!this.returnApp()) {
        this.$emit('back', e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fb-head {
  position: fixed;
  z-index: 500;
  top: 0;
  left: 0;
  width: 100%;
  height: 44px;
  padding: 14px 15px;
  background-color: $color;
  user-select: none;
  &.head-white {
    background-color: #fff;
    .fb-head-title {
      color: #1f2533;
    }
    .fb-head-right {
      color: #4e5666;
    }
  }
  &.no-fixed {
    position: relative;
  }
  &-back {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 15px;
    .back-icon {
      height: 20px;
    }
  }
  &-title {
    position: absolute;
    top: 50%;
    left: 50%;
    line-height: 17px;
    color: #fff;
    font-size: 18px;
    transform: translate(-50%,-50%);
  }
  &-right {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 15px;
    line-height: normal;
    color: #fff;
    font-size: 15px;
  }
  .right-img {
    width: 20px;
    height: 19px;
    background: url(../../assets/images/common/sevice_icon.png) center/cover;
  }
  .right-icon {
    width: 20px;
    height: 19px;
    background: url(../../assets/images/common/serve-help.png) center/cover;
  }

  .slot-titlt-warp {
    display: flex;
    justify-content: center;
  }
  .long-title-style {
    width: 64%;
    text-align: center;
  }
}
</style>
